import React, { useEffect } from "react";
import { MsalProvider, useMsal } from "@azure/msal-react";
import {
  EventType,
  InteractionType,
  PublicClientApplication,
} from "@azure/msal-browser";
import { msalConfigLogin, msalConfigReset } from "./authConfig";
import { b2cPolicies } from "./Policies";

import auth from "../Helpers/auth";
import axios from "axios";
import * as constants from "../global/const";

import jwt_decode from "jwt-decode";

const SignInPopup = (updateLoad, instance) => {
  //const { instance } = useMsal()
  // const instance = new PublicClientApplication(msalConfigLogin)
  const instanceR = new PublicClientApplication(msalConfigReset);

  const handlePopup = (msalinstance, msalConfig) => {
    updateLoad(true);
    msalinstance
      .loginPopup(msalConfig)
      .then(handleResponse)
      .catch((e) => {
        updateLoad(false);
      });
  };

  const handleResponse = (response) => {
    if (response != null) {
      auth.setToken(response.idToken);
      var decodeToken = jwt_decode(response.idToken);
      var exp = new Date(decodeToken.exp * 1000);
      localStorage.setItem("exp", exp.toString());

      setTimeout(() => {
        try {
          axios
            .post(constants.VALIDARLOGIN, {
              correo: response.account.idTokenClaims.emails[0],
            })
            .then((resp) => {
              auth.setUsuario(
                JSON.stringify({
                  name: resp.data.cliente.nombre,
                  email: resp.data.cliente.correo,
                  homeAccountId: response.account.homeAccountId,
                  username: response.account.username,
                  nombreNegocio: resp.data.cliente.nombre,
                  urlFoto: resp.data.cliente.identificacionPrincipal,
                  as400: resp.data.cliente.codigoAS400,
                  bodega: resp.data.cliente.bodega,
                  id: resp.data.cliente.id,
                  nit: resp.data.cliente.identificacion,
                  nitPrincipal: resp.data.cliente.identificacionPrincipal,
                  tipoClienteUsuario: resp.data.cliente.tipoClienteUsuario,
                })
              );
              window.location.href = "./inicio";
            })
            .catch((e) => {
              handleError();
            });
        } catch (e) {
          handleError();
        }
      }, 500);
    } else {
      updateLoad(false);
    }
  };

  const handleError = () => {
    auth.signOut();
    instance.logoutPopup(msalConfigLogin).then((response) => {
      auth.signOut();
      setTimeout(() => {
        window.location.href = "./";
      }, 500);
    });
  };

  handlePopup(instance, msalConfigLogin);
};

export default SignInPopup;
